import { useSelector } from 'react-redux';
import { selectSelectedResource } from '../slices/preferencesSlice';

const useSelectedResource = () => {
  return useSelector(selectSelectedResource);
};

export default useSelectedResource;